var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProcess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1551px",
    height: "477px",
    viewBox: "0 0 1551 477",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "process") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-2.0%",
    y: "-12.6%",
    width: "104.1%",
    height: "125.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "process",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 1551,
    height: 477
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    filter: "url(#filter-1)",
    transform: "translate(23.000000, 125.000000)",
    fill: "#000000",
    fillOpacity: 0.3
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 63,
    cy: 119,
    r: 63
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    cx: 166,
    cy: 119,
    r: 75
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-7",
    cx: 340,
    cy: 120,
    r: 119
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-8",
    cx: 551,
    cy: 119,
    r: 119
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-10",
    cx: 735,
    cy: 120,
    r: 88
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-11",
    cx: 844,
    cy: 120,
    r: 51
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-12",
    cx: 988,
    cy: 119,
    r: 119
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-13",
    cx: 1090,
    cy: 118,
    r: 77
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-14",
    cx: 1256,
    cy: 119,
    r: 119
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-17",
    cx: 1395,
    cy: 119,
    r: 75
  })), /*#__PURE__*/React.createElement("text", {
    id: "Data-Exploration",
    fontFamily: "OpenSans-Regular, Open Sans",
    fontSize: 14,
    fontWeight: "normal",
    fill: "#2C2D32"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 90,
    y: 58
  }, "Data Exploration")), /*#__PURE__*/React.createElement("text", {
    id: "User-Analysis",
    fontFamily: "OpenSans-Regular, Open Sans",
    fontSize: 14,
    fontWeight: "normal",
    fill: "#2C2D32"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 193,
    y: 438
  }, "User Analysis")), /*#__PURE__*/React.createElement("text", {
    id: "Idea-Synthesising",
    fontFamily: "OpenSans-Regular, Open Sans",
    fontSize: 14,
    fontWeight: "normal",
    fill: "#2C2D32"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 578,
    y: 437
  }, "Idea Synthesising")), /*#__PURE__*/React.createElement("text", {
    id: "Idea-Visualizing",
    fontFamily: "OpenSans-Regular, Open Sans",
    fontSize: 14,
    fontWeight: "normal",
    fill: "#2C2D32"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 762,
    y: 77
  }, "Idea Visualizing")), /*#__PURE__*/React.createElement("text", {
    id: "Prototyping",
    fontFamily: "OpenSans-Regular, Open Sans",
    fontSize: 14,
    fontWeight: "normal",
    fill: "#2C2D32"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1015,
    y: 71
  }, "Prototyping")), /*#__PURE__*/React.createElement("text", {
    id: "Expert-Feedback",
    fontFamily: "OpenSans-Regular, Open Sans",
    fontSize: 14,
    fontWeight: "normal",
    fill: "#2C2D32"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1117,
    y: 376
  }, "Expert Feedback")), /*#__PURE__*/React.createElement("text", {
    id: "Development",
    fontFamily: "OpenSans-Regular, Open Sans",
    fontSize: 14,
    fontWeight: "normal",
    fill: "#2C2D32"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1283,
    y: 69
  }, "Development")), /*#__PURE__*/React.createElement("text", {
    id: "Usability-Testing",
    fontFamily: "OpenSans-Regular, Open Sans",
    fontSize: 14,
    fontWeight: "normal",
    fill: "#2C2D32"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1422,
    y: 382
  }, "Usability Testing")), /*#__PURE__*/React.createElement("text", {
    id: "Brainstorming",
    fontFamily: "OpenSans-Regular, Open Sans",
    fontSize: 14,
    fontWeight: "normal",
    fill: "#2C2D32"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 367,
    y: 51
  }, "Brainstorming")), /*#__PURE__*/React.createElement("text", {
    id: "User-Feedback",
    fontFamily: "OpenSans-Regular, Open Sans",
    fontSize: 14,
    fontWeight: "normal",
    fill: "#2C2D32"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 871,
    y: 395
  }, "User Feedback")), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(82.000000, 177.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    stroke: "#000000",
    cx: 4,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3",
    fill: "#000000",
    cx: 4,
    cy: 4,
    r: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy",
    transform: "translate(185.000000, 315.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    stroke: "#000000",
    cx: 4,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3",
    fill: "#000000",
    cx: 4,
    cy: 4,
    r: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-6",
    transform: "translate(359.000000, 121.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    stroke: "#000000",
    cx: 4,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3",
    fill: "#000000",
    cx: 4,
    cy: 4,
    r: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-9",
    transform: "translate(754.000000, 153.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    stroke: "#000000",
    cx: 4,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3",
    fill: "#000000",
    cx: 4,
    cy: 4,
    r: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-11",
    transform: "translate(1007.000000, 121.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    stroke: "#000000",
    cx: 4,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3",
    fill: "#000000",
    cx: 4,
    cy: 4,
    r: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-13",
    transform: "translate(1275.000000, 121.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    stroke: "#000000",
    cx: 4,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3",
    fill: "#000000",
    cx: 4,
    cy: 4,
    r: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-16",
    transform: "translate(1414.000000, 315.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    stroke: "#000000",
    cx: 4,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3",
    fill: "#000000",
    cx: 4,
    cy: 4,
    r: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-7",
    transform: "translate(570.000000, 359.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    stroke: "#000000",
    cx: 4,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3",
    fill: "#000000",
    cx: 4,
    cy: 4,
    r: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-10",
    transform: "translate(863.000000, 292.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    stroke: "#000000",
    cx: 4,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3",
    fill: "#000000",
    cx: 4,
    cy: 4,
    r: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-12",
    transform: "translate(1109.000000, 316.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    stroke: "#000000",
    cx: 4,
    cy: 4,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-3",
    fill: "#000000",
    cx: 4,
    cy: 4,
    r: 2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M86.25,176.5 L86.25,47.5",
    id: "Line-5",
    stroke: "#000000",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.25,441.5 L189.25,323.5",
    id: "Line-5-Copy",
    stroke: "#000000",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.25,440.5 L574.25,367.5",
    id: "Line-5-Copy-7",
    stroke: "#000000",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M867.208333,398.5 L867.208333,300.5",
    id: "Line-5-Copy-11",
    stroke: "#000000",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1113.20139,380.5 L1113.20139,324.5",
    id: "Line-5-Copy-13",
    stroke: "#000000",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1418.20004,384.5 L1418.20004,323.5",
    id: "Line-5-Copy-17",
    stroke: "#000000",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.25,120.5 L363.25,41.5",
    id: "Line-5-Copy-8",
    stroke: "#000000",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758.208333,152.5 L758.208333,67.5",
    id: "Line-5-Copy-10",
    stroke: "#000000",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.20023,120.5 L1011.20023,61.5",
    id: "Line-5-Copy-12",
    stroke: "#000000",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1279.20001,120.5 L1279.20001,57.5",
    id: "Line-5-Copy-14",
    stroke: "#000000",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M867.729711,261.151046 C868.566405,255.555633 869,249.828452 869,244 C869,180.487254 817.512746,129 754,129 C698.363968,129 651.955634,168.508473 641.300417,221 L641,221 L597.5,182.924569 C614.604112,181.930127 623.156169,181.432906 623.156169,181.432906 C646.514138,132.67352 696.324633,99 754,99 C834.081289,99 899,163.918711 899,244 C899,251.774461 898.388145,259.406016 897.209962,266.849137 C897.209962,266.849137 887.383211,264.949773 867.72971,261.151046 Z",
    id: "Combined-Shape",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1377.186,221 L1470.5,221 C1482.92641,221 1493,231.073593 1493,243.5 L1493,244.5 C1493,256.926407 1482.92641,267 1470.5,267 L45.5,267 C33.0735931,267 23,256.926407 23,244.5 L23,243.5 C23,231.073593 33.0735931,221 45.5,221 L1121,221 L1077.5,182.924569 C1094.60411,181.930127 1103.15617,181.432906 1103.15617,181.432906 C1126.51414,132.67352 1176.32463,99 1234,99 C1306.25429,99 1366.16509,151.848795 1377.186,221 Z M1121.30042,221 L1346.69958,221 C1336.04437,168.508473 1289.63603,129 1234,129 C1178.36397,129 1131.95563,168.508473 1121.30042,221 Z",
    id: "Combined-Shape",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("text", {
    id: "RESEARCH",
    fontFamily: "OpenSans-Regular, Open Sans",
    fontSize: 18,
    fontWeight: "normal",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 133.409668,
    y: 251
  }, "RESEARCH")), /*#__PURE__*/React.createElement("text", {
    id: "DESIGN",
    fontFamily: "OpenSans-Regular, Open Sans",
    fontSize: 18,
    fontWeight: "normal",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 546.147461,
    y: 251
  }, "DESIGN")), /*#__PURE__*/React.createElement("text", {
    id: "PROTOTYPE",
    fontFamily: "OpenSans-Regular, Open Sans",
    fontSize: 18,
    fontWeight: "normal",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1056.29346,
    y: 251
  }, "PROTOTYPE")), /*#__PURE__*/React.createElement("text", {
    id: "EVALUATION",
    fontFamily: "OpenSans-Regular, Open Sans",
    fontSize: 18,
    fontWeight: "normal",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1304.40527,
    y: 251
  }, "EVALUATION")), /*#__PURE__*/React.createElement("text", {
    id: "ITERATION",
    fontFamily: "OpenSans-Regular, Open Sans",
    fontSize: 18,
    fontWeight: "normal",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 1190.09326,
    y: 124
  }, "ITERATION")), /*#__PURE__*/React.createElement("text", {
    id: "ITERATION-Copy",
    fontFamily: "OpenSans-Regular, Open Sans",
    fontSize: 18,
    fontWeight: "normal",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 713.093262,
    y: 124
  }, "ITERATION")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcess);
export default __webpack_public_path__ + "static/media/process.8c1a1bbfa175dfa7b1dbcaa9fb0a6c81.svg";
export { ForwardRef as ReactComponent };